import firebase from "./Firebase.service";

export const auth = firebase.auth();

export const signInWithSocialLogin = (provider) => {
   
   return auth.signInWithPopup(provider).then((res) => {

        console.log('logged in successfully',res.user);
        return res.user;
       
    }).catch((error) => {
      console.log(error.message)
    })
}